var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('gl-switch',{attrs:{"value":_vm.excludeSameItem},on:{"input":function($event){return _vm.$emit('update:excludeSameItem', $event)}}},[_vm._v("\n    対象と同じ商品は比較から除外する\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }